// extracted by mini-css-extract-plugin
export default {"appPageStickyHeader":"_1h81oqf","hideOnMobile":"_zvnzjm"};